<template>
  <div v-show="show"  class="row">
   <!-- <b-table class="col-3" stacked :items="items" :fields="fields"></b-table>-->
    <video  id="mainVideo" class="col-12"  controls :src="url"></video>
    <div class="col-12" style="overflow: scroll;">
      <b-table  :items="items" :fields="fields"></b-table>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-console */
import Http from "../Http";

export default {
  name: "video",
  props: ["falla", "show"],
  watch: {
    falla() {
      this.items = [];
      console.log("dsdds--->");
      if (this.falla != null) {
        this.url = `http://${Http.ip}/uploads/${this.falla.video.video_ruta}`;
        this.items.push(this.falla);
        setTimeout(() => {
          let video = document.getElementById("mainVideo");
          video.currentTime = this.falla.reporte_tiempo;
        }, 100);
      }
    }
  },
  data: () => ({
    url: "",
    items: [],
    fields: [
      {
        key: "reporte_contrato",
        label: "Contrato"
      },
      {
        key: "reporte_estadoPago",
        label: "EP"
      },
      {
        key: "reporte_zona",
        label: "Zona"
      },
      {
        key: "video.video_fechacreacion",
        label: "Fecha de Ejecución ITV",
        formatter: value => {
          return new Date(value).toLocaleDateString();
        }
      },
      {
        key: "reporte_localidad",
        label: "Localidad"
      },
      {
        key: "video.video_subcuenca",
        label: "Subcuenca"
      },
      {
        key: "video.video_tramo",
        label: "Identifica"
      },
      {
        key: "reporte_ciInicial",
        label: "Ci Inicial"
      },
      {
        key: "reporte_ciFinal",
        label: "Ci_final"
      },
      {
        key: "reporte_direccion",
        label: "Direccion"
      },
      {
        key: "reporte_desde",
        label: "Desde"
      },
      {
        key: "reporte_hasta",
        label: "Hasta"
      },
      {
        key: "reporte_largototal",
        label: "Lonitud Tramo"
      },
      {
        key: "reporte_largoinpec",
        label: "Longitud Ispeccion"
      },
      {
        key: "reporte_gravedad",
        label: "Sentido Grabacion"
      },
      {
        key: "reporte_diametro",
        label: "DIametro Tramo"
      },
      {
        key: "reporte_material",
        label: "Material"
      },
      {
        key: "anomalia.anomalia_nombre",
        label: "Falla Detectada"
      },
      {
        key: "reporte_lfalla",
        label: "Ubicacion de Falla"
      },
      {
        key: "reporte_gravedad",
        label: "Gravedad de Falla"
      },
      {
        key: "solucion.solucion_nombre",
        label: "Propuesta De Solucion"
      },
      {
        key: "reporte_observacion",
        label: "Observacion"
      }
    ]
  }),
  mounted() {
    console.log("montado --->");
  }
};
</script>

<style scoped></style>
